// src/app/core/mainPage/mainPagecomp/TopModelsSection/LatestModelCard.tsx
import { motion } from "motion/react";
import { ArrowRight, Calendar, Sparkles } from "lucide-react";
import type { LatestModelData } from "./types";
import { useTranslation } from "@/app/core/ui/theme/LanguageProvider";

interface LatestModelCardProps {
  data: LatestModelData;
  onSelect: () => void;
}

export function LatestModelCard({ data, onSelect }: LatestModelCardProps) {
  const { t } = useTranslation();

  return (
    <motion.button
      whileHover={{ scale: 1.01 }}
      whileTap={{ scale: 0.98 }}
      onClick={onSelect}
      className="relative w-full h-44 rounded-2xl overflow-hidden border border-border shadow-lg focus:outline-none focus:ring-2 focus:ring-accent"
    >
      <img
        src={data.background}
        alt={data.name}
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-black/10" />

      <div className="absolute bottom-0 left-0 right-0 p-5 text-left text-white">
        <div className="flex items-center gap-2 mb-2">
          <Sparkles className="w-5 h-5 text-accent" />
          <h3 className="text-lg font-bold drop-shadow">{data.name}</h3>
        </div>
        <p className="text-sm text-white/80 mb-3 line-clamp-2 drop-shadow">
          {data.description}
        </p>
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-1.5 text-xs text-white/60">
            <Calendar className="w-3.5 h-3.5" />
            {t('addedDate')}: {data.dateAdded}
          </div>
          <span className="inline-flex items-center gap-1 text-sm font-medium text-accent">
            {t('tryModel')} <ArrowRight className="w-4 h-4" />
          </span>
        </div>
      </div>
    </motion.button>
  );
}